export type ProjectCardData = {
  title: string;
  year_period: string;
  category: string;
  description?: string | null;
  cover_image?: string | null;
  cover_alt?: string | null;
};

const borders = ['border-primary', 'border-secondary', 'border-accent'];

export function ProjectCard({ project, index = 0 }: { project: ProjectCardData; index?: number }) {
  return (
    <div className={`bg-card rounded-panel p-6 border-l-4 ${borders[index % borders.length]} shadow-sm`}>
      {project.cover_image && <img src={project.cover_image} alt={project.cover_alt?.trim() || project.title} loading="lazy" className="w-full aspect-video object-cover rounded mb-4" />}
      <span className="text-xs font-semibold bg-muted text-muted-foreground px-2 py-0.5 rounded-full">{project.category}</span>
      <p className="text-sm text-muted-foreground mt-3">{project.year_period}</p>
      <h3 className="font-heading font-bold text-lg mt-1">{project.title}</h3>
      {project.description && <p className="text-sm text-muted-foreground mt-3 whitespace-pre-line">{project.description}</p>}
    </div>
  );
}